import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=8a8d7fbe"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports